import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import ConnectAccountStep from './ConnectAccountStep'
import OverviewStep from './OverviewStep'
import SetupCompleteStep from './SetupCompleteStep'
import { useGoogleMessagesIntegrationData } from 'src/containers/Settings/InstantResponders/hooks'
import useAccountContext from 'src/contexts/AccountContext'
import Wizard from 'src/stories/Wizard'
import { getActiveLocation, generateLocationUrl } from 'src/utils'
import { UseLocationRouteParams } from 'src/utils/interfaces'

const GoogleMessagesConnectionWizard: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const navigate = useNavigate()
  const { locationId, merchantId } = useParams<UseLocationRouteParams>()
  const { locations } = useAccountContext()
  const activeLocation = getActiveLocation(locations, locationId)
  const { isConnected } = useGoogleMessagesIntegrationData({ activeLocation })

  const nextStep = () => {
    setCurrentIndex((index) => index + 1)
  }
  const previousStep = () => setCurrentIndex((index) => index - 1)
  const exitWizard = () => {
    const instantRespondersSettingsSection = generateLocationUrl(
      merchantId!,
      locationId!,
      '/settings#section-settings-instant-responders'
    )

    navigate(instantRespondersSettingsSection)
  }

  // If Google Messages integration is connected we redirect to the IR screen
  if (isConnected) {
    exitWizard()
  }

  const stepLabels = [{ label: 'Overview' }, { label: 'Enter account info' }]
  const stepContent = [
    <OverviewStep nextStep={nextStep} />,
    <ConnectAccountStep nextStep={nextStep} previousStep={previousStep} />,
    <SetupCompleteStep nextStep={exitWizard} />,
  ]

  return (
    <Wizard
      title="Connect Google Business Messages"
      onClickGoBack={exitWizard}
      steps={stepLabels}
      currentStepIndex={currentIndex}
      onClickStep={(index, step) => setCurrentIndex(index)}
      disabled={currentIndex === 2}
    >
      {stepContent[currentIndex]}
    </Wizard>
  )
}

export default GoogleMessagesConnectionWizard
